import api from './client';
import type { PlanningTemplate } from 'types/planning_template';
import type { ListParams } from './types';

export const planningTemplatesApi = {
  list: async (params?: ListParams & { org_id?: string }): Promise<PlanningTemplate[]> => {
    const { data } = await api.get('/planning-templates', { params });
    return data as PlanningTemplate[];
  },

  get: async (id: string): Promise<PlanningTemplate> => {
    const { data } = await api.get(`/planning-templates/${id}`);
    return data as PlanningTemplate;
  },

  create: async (payload: any): Promise<PlanningTemplate> => {
    const { data } = await api.post('/planning-templates', payload);
    return data as PlanningTemplate;
  },

  update: async (id: string, updates: any): Promise<PlanningTemplate> => {
    const { data } = await api.patch(`/planning-templates/${id}`, updates);
    return data as PlanningTemplate;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/planning-templates/${id}`);
  },
};
